/**
 * Error classes for API operations
 * Separated to avoid circular dependencies between api module and hooks
 */

export class APIRequestError extends Error {
    constructor(
        message: string,
        public statusCode?: number,
        public response?: any
    ) {
        super(message);
        this.name = `APIRequestError: ${statusCode} ${message}`;
    }
}
